import { tsInitVueGrid } from './js-utils'

document.addEventListener('DOMContentLoaded', function () {
  const digestReportGridEl = document.querySelector('div[data-is="OspeActivityDigestGrid"]')
  if (digestReportGridEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      const grid = await import('./vue-components/ospe/ospe-activity-digest-grid.vue')
      tsInitVueGrid(grid.default, digestReportGridEl, {
        initialFilters: digestReportGridEl.dataset.initialFilters
      })
    })()
  }
})
